import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import Tabs from '@uikit/components/Tabs/Tabs';
import { TabsItem } from '@uikit/components/Tabs/interfaces';
import React from 'react';
import type { TabsContainerProps } from './types';

const TabsContainer = ({ children, ...props }: TabsContainerProps) => {
  if (!children) {
    return null;
  }

  const items: TabsItem[] = React.Children.map(children, (child) => {
    const childProps = child.props as any;

    if (!React.isValidElement(child) || !childProps?.item) {
      return null;
    }

    const {
      props: { headline, icon },
      contents,
    } = childProps.item;

    const navItem = { headline, icon };

    const content =
      contents?.length > 0 ? (
        <div>
          {
            <ContentsToReact
              contents={contents}
              cmsComponents={childProps.cmsComponents}
            />
          }
        </div>
      ) : null;

    return { navItem, content };
  }).filter(Boolean);

  if (items.length < 1) {
    return null;
  }

  return <Tabs items={items} {...props} />;
};

export default TabsContainer;
